
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/standing-order-invoices",
      function () {
        return require("private-next-pages/admin/standing-order-invoices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/standing-order-invoices"])
      });
    }
  